import React, { useState } from "react";
import "./CheckBox.scss";

export default function CheckBox({
  title = "",
  icon = "",
  className = "",
  onChange = () => null,
  name = "",
  checked = false,
}) {
  return (
    <div className={`checkbox ${className}`}>
      <div style={{ width: "20px", height: "20px" }}>
        <input
          type="checkbox"
          id={name}
          name={name}
          value="sim"
          checked={checked}
          onChange={onChange}
        />
      </div>
      <span className="check"></span>
      <p>{title}</p>
    </div>
  );
}
